<template>
  <div class="commoditysearch">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <!-- 搜索框 -->
      <section class="search_con">
        <div v-if="datas.styleType != 1" class="search_user_img">
          <i class="iconfont icon-touxiang" />
        </div>
        <div
          class="search_input_con"
          :style="{
            'background-color': datas.searchBgColor,
            border: '1px solid ' + datas.searchBorderColor,
          }"
        >
          <i
            class="iconfont icon-sousuo"
            :style="{
              color: datas.searchIconColor,
              'font-size': datas.wordSize + 'px',
              'margin-right': '5px',
            }"
          />

          <span
            :style="{
              color: datas.wordColor,
              'font-size': datas.wordSize + 'px',
              'font-weight': datas.isBold ? 'bold' : 'normal',
              'font-style': datas.isTilt ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLine ? 'underline' : 'none',
            }"
            >{{ datas.searchTitle }}</span
          >
        </div>
      </section>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "Commoditysearch",
  props: {
    datas: Object,
  },
  data() {
    return {
      searchVal: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.commoditysearch {
  position: relative;
  /* 搜索框 */
  .search_con {
    display: flex;
    align-items: center;
    .search_user_img {
      .iconfont {
        font-size: 68px;
      }
      margin-right: 20px;
    }
    .search_input_con {
      display: flex;
      align-items: center;
      border-radius: 50px;
      flex: 1;
      padding: 7px 14px;
      height: 68px;
      box-sizing: border-box;
    }
    .search_store_con {
      display: flex;
      align-items: center;
      margin-left: 20px;
      // padding-right: 10px;
      .iconfont {
        margin-left: 10px;
      }
      ::v-deep {
        .van-dropdown-menu__bar {
          height: 34px;
          .van-dropdown-menu__title {
            padding: 0 2px;
          }
        }
        .vpn_title {
          visibility: hidden;
        }
      }

      .store_text_con {
        position: absolute;
        pointer-events: none;
      }
    }
  }
}
</style>
